<template>
    <div>
        <my-form ref="website_form">
            <div class="col-lg-5 ma-auto">
                <div class="mb-8">
                    <h1 class="text-center display-1 font-weight-bold">{{$t('Thanks,')}} {{user.first_name}} {{$t('Let’s set up your account.')}}</h1>
                </div>
                <label class="my-label">{{$t('What is your website name?')}}</label>
                <div class="col-12 px-0">
                    <v-text-field :error-messages="errors.name" :rules="[validationRules.required]" v-model="website.name" outlined :label="$t('Website name')"></v-text-field>
                </div>
                <label class="my-label">{{$t('URL to your website')}}</label>
                <div class="col-12 px-0">
                    <v-text-field :error-messages="errors.url" :rules="[validationRules.required]" v-model="website.url" outlined :label="$t('URL')">
                        <template v-slot:append-outer><v-chip>.{{$root.base_url | stripeHttp}}</v-chip></template>
                    </v-text-field>
                </div>
                <label class="my-label">{{$t('About how many people work at your company')}}</label>
                <div class="col-12 px-0">
                    <v-select :items="employeeItems"  item-text="name" item-value="value" v-model="website.data.employees" outlined :label="$t('Employees')"></v-select>
                </div>
                <label class="my-label">{{$t('What kind of business are you in?')}}</label>
                <div class="col-12 px-0">
                    <v-select :items="businessItems"  item-text="name" item-value="value" v-model="website.data.business" outlined :label="$t('Business')"></v-select>
                </div>
                <div class="col-6 ma-auto mt-4">
                    <v-btn :loading="loading" color="primary" @click="($refs.website_form.my_validate())? save() : null" x-large class="w-100" dark>{{$t('Save changes')}}</v-btn>
                    <v-btn class="w-100 mt-3" to="/informations/profile" color="primary" text>{{$t('Previous')}}</v-btn>
                </div>
            </div>
        </my-form>
        <v-dialog :width="dialogWidth" :value="dialog" persistant>
            <v-card>
                <v-card-title>{{$t('Nice! You did it 🎉')}}</v-card-title>
                <v-card-text>
                    {{$t('You can now add your products.')}}
                    <br>
                    {{$t('We will redirect you in a while. Please wait')}}
                    <br>
                    <v-progress-circular
                            class="mt-3 w-100"
                            indeterminate
                            color="primary"
                    ></v-progress-circular>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import {editBread, storeBread} from "../../api/bread";
    import {update} from "../../api/user";

    export default {
        data:() => {
            return{
                errors:{},
                website:{
                    data:{}
                },
                dialog: false,
                employeeItems:[
                    {
                        name: '20 or fewer employees',
                        value: '<=20',
                    },
                    {
                        name: 'More then 20 but fewer than 50',
                        value: '>20 <50'
                    },
                    {
                        name: 'More than 50',
                        value: '>50'
                    }
                ],
                businessItems:[
                    {
                        name: 'E-commerce',
                        value: 'e-commerce',
                    },
                    {
                        name: 'Car repair shop',
                        value: 'car repair shop'
                    },
                    {
                        name: 'Delivery service',
                        value: 'Delivery service'
                    }
                ],
                loading:false,
            }
        },
        mounted(){
            if(this.websites && this.websites.length > 0){
                this.website = this.websites[0];
                if(!this.website.data.employees){
                    this.$set(this.website.data, 'employees', this.employeeItems[0].value);
                }
            }
        },
        computed:{
            activeWebsite(){
                return this.$store.getters.activeWebsite;
            },
            websites(){
                return this.$store.getters.websites;
            },
            user(){
                return this.$store.getters.user;
            }
        },
        methods:{
            save(){
                if(this.website.id){
                    var func = editBread('Website', this.website, this.website.id);
                    var adding = false;
                }else{
                    var func = storeBread('Website', this.website);
                    var adding = true;
                }
                this.loading = true;
                update({...this.user, information_ended_at: 1}, this.user.id).then(res => {
                    func.then(res => {
                        this.loading = false;
                        this.dialog = true;
                        this.$store.dispatch('user/getUser');
                        this.$store.dispatch('websites/getWebsites').then(res => {
                            this.$store.dispatch('websites/setActive', this.websites[0]);
                            setTimeout(() => {
                                if(adding){
                                    var message = this.$t('We created for you first simple product. You can edit it or delete, as you wish.');
                                    this.$router.push('/websites/'+this.activeWebsite.id+'?message='+message);
                                }else{
                                    var message = this.$t('We created for you first simple product. You can edit it or delete, as you wish.');
                                    this.$router.push('/websites/design/'+this.activeWebsite.id+'?message='+message);
                                }
                            },4000)
                        });
                    }).catch(e => {
                        this.loading = false;
                        if(e.response.data && e.response.data.errors){
                            this.errors = e.response.data.errors;
                        }
                    })
                })
            }
        }
    }
</script>
